import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Button,
  Box,
  Alert,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { applyActionCode } from "firebase/auth";
import firebaseAuthRef from "../firebase_auth"

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    maxWidth: 400,
    padding: theme.spacing(2),
    margin: 'auto',
    textAlign: 'center',
  },
}));

interface VerifyEmailProps {}

const VerifyEmail: React.FC<VerifyEmailProps> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const actionCode = queryParams.get('oobCode') ?? ''
  const continueUrl = queryParams.get('continueUrl') ?? ''
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      if (!actionCode) {
        setError('Invalid actionCode');
        return;
      }

      applyActionCode(firebaseAuthRef, actionCode).then((resp) => {
        setSuccess(false)
      }).catch((error) => {
        setError(error.message)
        setSuccess(false)
      });

    };
    verifyEmail();
  }, [actionCode]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box className={classes.message} sx={{ backgroundColor: 'white', padding: 2, borderRadius: 1 }}>
          {success ? (
            <Alert severity="success">
              Email verified successfully!
            </Alert>
          ) : (
            <Typography variant="h5">Verifying Email...</Typography>
          )}
          {error && (
            <Alert severity="error">
              {error}
            </Alert>
          )}
          {success && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(continueUrl)}
              sx={{ marginTop: 2 }}
            >
              Go to the App
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default VerifyEmail;